/* *
 * Author:CJW
 * Time:2023.11.14
 * */

export function extractRGBValues (rgbString) {
  const regex = /\d+/g
  const matches = rgbString.match(regex)

  if (matches && matches.length === 3) {
    return matches.map(Number)
  } else {
    // 处理匹配失败的情况，例如输入不是有效的 RGB 字符串
    console.error('Invalid RGB string:', rgbString)
    return null
  }
}
